// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
    --max-witdh: 980px;
    --adm-color-primary: #c3a07b;
    --adm-font-size-1: 16px;
    --adm-font-size-2: 17px;
    --adm-font-size-3: 18px;
    --adm-font-size-4: 19px;
    --adm-font-size-5: 20px;
    --adm-font-size-6: 21px;
    --adm-font-size-7: 22px;
    --adm-font-size-8: 23px;
    --adm-font-size-9: 24px;
    --adm-font-size-10: 25px;
}

body, .page {
    /*height: 100%;*/
    /*overflow: hidden;*/
}

.page {
    margin: auto;
    max-width: var(--max-witdh);
    font-family: 'appFont';
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;AAC1B","sourcesContent":["#root {\r\n    --max-witdh: 980px;\r\n    --adm-color-primary: #c3a07b;\r\n    --adm-font-size-1: 16px;\r\n    --adm-font-size-2: 17px;\r\n    --adm-font-size-3: 18px;\r\n    --adm-font-size-4: 19px;\r\n    --adm-font-size-5: 20px;\r\n    --adm-font-size-6: 21px;\r\n    --adm-font-size-7: 22px;\r\n    --adm-font-size-8: 23px;\r\n    --adm-font-size-9: 24px;\r\n    --adm-font-size-10: 25px;\r\n}\r\n\r\nbody, .page {\n    /*height: 100%;*/\r\n    /*overflow: hidden;*/\r\n}\r\n\r\n.page {\r\n    margin: auto;\r\n    max-width: var(--max-witdh);\r\n    font-family: 'appFont';\r\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
